import Grid from 'components/core/Grid';
import { Card, CardContent, Typography, Box, Button, Link } from '@mui/material';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';

import React from 'react';
import styled from 'styled-components';

const StyledBox = styled(Box)`
  display: flex;

  & .MuiButton-root {
    min-width: 130px;
    margin-left: 16px;  
  }

  ${props => props.theme.breakpoints.down('sm')} {
    flex-direction: column;

    & .MuiButton-root {
    min-width: 100%;
    margin-left: 0px;
    margin-top: 8px;
  }
}
`;

export const ClaimPerkModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {

  return (
    <ConfirmationDialog
      dialogTitle="Claim Your Perk..."
      isDialogOpen={isOpen}
      handleCloseDialog={() => {
        closeModal();
      }}
      hasBottomBar={false}
      hasHeaderBar={true}
      padding={0}
      maxWidth="sm"
      isFullScreen={false}
    >
      <Grid container>
        <Grid item xs={12} p={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="body1" fontWeight={500}>1: Buy Winter Season Pass</Typography>
                  <StyledBox>
                    <Typography variant="body2">Buy a Winter Season Pass before November 27th to receive $100.00 and any time in the season for $50.00</Typography>
                    <Button target="_blank" href="https://www.bigwhite.com/season-passes?utm_source=alluraDirect&utm_medium=alluraUniversal&utm_campaign=alluraUniversal&utm_id=alluraPerk&utm_term=alluraUniversal&utm_content=alluraUniversal" color="secondary" variant="contained">Buy Now</Button>
                  </StyledBox>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="body1" fontWeight={500}>2: Forward Receipt to alluraDirect</Typography>
                  <StyledBox>
                    <Typography variant="body2">Forward the email receipt from Big White to <Link href="mailto:info@alluradirect.com">info@alluradirect.com</Link>.  Please make sure your name and email matches your allura guest account.</Typography>
                    <Button color="secondary" variant="contained" href="mailto:info@alluradirect.com">Send Email</Button>
                  </StyledBox>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="body1" fontWeight={500}>3: Book Accommodation</Typography>
                  <StyledBox>
                    <Typography variant="body2">Within 48 hours the receipt will be verified and the credit will be applied to the email address of the season passholder and will be available to use.</Typography>
                    <Button color="secondary" variant="contained" href="https://www.alluradirect.com/bigwhite-accommodations.cfm" target="_blank">Search Now</Button>
                  </StyledBox>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ConfirmationDialog>
  );
};
